export enum GameType {
    DL_NTSC = "DL_NTSC",
    UYA_NTSC = "UYA_NTSC",
    UYA_PAL = "UYA_PAL",
}
